/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, position: NonNullable<unknown>, total: NonNullable<unknown> }} Settings_Templates_Drag_StartInputs */



/**
* | output |
* | --- |
* | "{name} picked up. Position {position} of {total}." |
*
* @param {Settings_Templates_Drag_StartInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_templates_drag_start = /** @type {((inputs: Settings_Templates_Drag_StartInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Templates_Drag_StartInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} opgepakt. Plaats ${i?.position} van ${i?.total}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} pris. Position ${i?.position} sur ${i?.total}.`)
	return /** @type {LocalizedString} */ (`${i?.name} picked up. Position ${i?.position} of ${i?.total}.`)
});